import { curryN, compose, prop } from 'ramda'
import { branch, nest } from 'recompose'
import Button from 'react-toolbox/lib/button/Button'

import { withTheme } from 'modules/util'
import Link from '../Link'

import buttonTheme from './theme.scss'

const branch2 = curryN(2, branch)
const nest2 = curryN(2, nest)

const hasLink = prop('to')
const wrapWithLink = nest2(Link)

export default compose(
  branch2(hasLink, wrapWithLink),
  withTheme(buttonTheme)
)(Button)



// WEBPACK FOOTER //
// ./client/modules/ui/components/Button/index.js